// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PAMHX","footerText":"Footer_footerText__JUstJ","dashboardFooter":"Footer_dashboardFooter__vk9sA"};